import { create } from 'zustand';

type TradePairSearchStore = {
  searchString: string;
  setSearchString: (value: string) => void;
  clearSearch: () => void;
};

export const useTradePairSearchStore = create<TradePairSearchStore>((set) => ({
  searchString: '',
  setSearchString: (value: string) => set({ searchString: value }),
  clearSearch: () => set({ searchString: '' }),
}));
